"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iEquipmentObject = exports.iEmployeeObject = exports.iDeleteWorksiteDiaryEntry = exports.iUpdateWorksiteDiaryEntry = exports.iCreateWorksiteDiaryEntry = exports.iWorksiteDiaryEntry = exports.isValidEquipmentOrEmployeeObject = exports.isAllValidEquipmentOrEmployeeObjects = exports.iWeatherObject = exports.isValidWeatherObject = void 0;
const t = require("io-ts");
const Comment = require("./worksiteDiaryEntryComment");
const Job = require("./worksiteDiaryJob");
const file_1 = require("./file");
// import * as Weather from './weather'
const _iWeatherObject = t.partial({
    tempAt7: t.union([t.number, t.null]),
    conditionAt7: t.string,
    disturbanceAt7: t.boolean,
    tempAt12: t.union([t.number, t.null]),
    conditionAt12: t.string,
    disturbanceAt12: t.boolean
});
function isValidWeatherObject(obj) {
    const validProperties = [
        'tempAt7',
        'conditionAt7',
        'disturbanceAt7',
        'tempAt12',
        'conditionAt12',
        'disturbanceAt12'
    ];
    const validValuesTypes = ['number', 'string', 'boolean', 'number', 'string', 'boolean'];
    const objectProps = Object.getOwnPropertyNames(obj);
    if (objectProps.length > validProperties.length) {
        return false;
    }
    for (const property of objectProps) {
        const index = validProperties.indexOf(property);
        if (index === -1) {
            return false;
        }
        if (typeof obj[validProperties[index]] !== validValuesTypes[index]) {
            // Allow null temperatures
            if ((property === 'tempAt7' || property === 'tempAt12') &&
                obj[property] === null) {
                continue;
            }
            else {
                return false;
            }
        }
    }
    return true;
}
exports.isValidWeatherObject = isValidWeatherObject;
exports.iWeatherObject = t.clean(_iWeatherObject);
const _iEquipmentObject = t.interface({
    name: t.string,
    count: t.number
});
const _iEmployeeObject = t.interface({
    name: t.string,
    count: t.number
});
function isAllValidEquipmentOrEmployeeObjects(objects) {
    for (const obj of objects) {
        if (!isValidEquipmentOrEmployeeObject(obj)) {
            return false;
        }
    }
    return true;
}
exports.isAllValidEquipmentOrEmployeeObjects = isAllValidEquipmentOrEmployeeObjects;
function isValidEquipmentOrEmployeeObject(obj) {
    const validProperties = [
        'name',
        'count',
    ];
    const validValuesTypes = ['string', 'number'];
    const objectProps = Object.getOwnPropertyNames(obj);
    if (objectProps.length != validProperties.length) {
        return false;
    }
    for (const property of objectProps) {
        const index = validProperties.indexOf(property);
        if (index === -1) {
            return false;
        }
        if (typeof obj[validProperties[index]] !== validValuesTypes[index]) {
            return false;
        }
    }
    return true;
}
exports.isValidEquipmentOrEmployeeObject = isValidEquipmentOrEmployeeObject;
const _iWorksiteDiaryEntry = t.intersection([
    t.interface({
        id: t.number,
        entry_uuid: t.string,
        diary_uuid: t.string,
        created_by: t.string,
        diary_date: t.union([t.string, t.number])
    }),
    t.partial({
        updated_by: t.string,
        deleted_at: t.number,
        weather_info: _iWeatherObject,
        plan_info: t.string,
        review_info: t.string,
        small_critical_changes: t.string,
        change_offers: t.string,
        additional_time: t.string,
        supervisor_notes: t.string,
        additional_notes: t.string,
        employee_status: t.array(_iEmployeeObject),
        equipment_status: t.array(_iEquipmentObject),
        jobs: t.array(Job.iWorksiteDiaryJob),
        comments: t.array(Comment.iWorksiteDiaryEntryComment),
        other_notes: t.string,
        master_signature: t.string,
        supervisor_signature: t.string,
        created_at: t.number,
        updated_at: t.number,
        ui_diary_date: t.string,
        ui_created_at: t.string,
        ui_updated_at: t.string,
        workday: t.number,
        folder_uuid: t.string,
        folder_id: t.number,
        images_folder_uuid: t.string,
        images_folder_id: t.number,
        folder: file_1.iRevisionOrFolder,
        images_folder: file_1.iRevisionOrFolder,
        attachments: t.array(file_1.iRevisionOrFolder),
        images: t.array(file_1.iRevisionOrFolder),
        next_entry_uuid: t.string,
        previous_entry_uuid: t.string
    })
]);
const _iCreateWorksiteDiaryEntry = t.intersection([
    t.interface({
        diary_uuid: t.string,
        created_by: t.number,
        diary_date: t.union([t.string, t.number])
    }),
    t.partial({
        employee_status: t.array(_iEmployeeObject),
        equipment_status: t.array(_iEquipmentObject),
        folder_uuid: t.string,
        folder_id: t.number,
        images_folder_uuid: t.string,
        images_folder_id: t.number
    })
]);
const _iUpdateWorksiteDiaryEntry = t.intersection([
    t.interface({
        id: t.number,
        diary_uuid: t.string,
        entry_uuid: t.string
    }),
    t.partial({
        plan_info: t.string,
        weather_info: _iWeatherObject,
        review_info: t.string,
        small_critical_changes: t.string,
        change_offers: t.string,
        additional_time: t.string,
        additional_notes: t.string,
        supervisor_notes: t.string,
        employee_status: t.array(_iEmployeeObject),
        equipment_status: t.array(_iEquipmentObject),
        other_notes: t.string,
        master_signature: t.string,
        supervisor_signature: t.string
    })
]);
const _iDeleteWorksiteDiaryEntry = t.intersection([
    t.interface({
        entry_uuid: t.string,
        folder_id: t.number
    }),
    t.partial({
        job_ids: t.array(t.number),
        revision_ids: t.array(t.number),
        comment_ids: t.array(t.number)
    })
]);
exports.iWorksiteDiaryEntry = t.clean(_iWorksiteDiaryEntry);
exports.iCreateWorksiteDiaryEntry = t.clean(_iCreateWorksiteDiaryEntry);
exports.iUpdateWorksiteDiaryEntry = t.clean(_iUpdateWorksiteDiaryEntry);
exports.iDeleteWorksiteDiaryEntry = t.clean(_iDeleteWorksiteDiaryEntry);
exports.iEmployeeObject = t.clean(_iEmployeeObject);
exports.iEquipmentObject = t.clean(_iEquipmentObject);
//# sourceMappingURL=worksiteDiaryEntry.js.map